import { render, staticRenderFns } from "./StatConstructor.vue?vue&type=template&id=072d99fb&scoped=true&"
import script from "./StatConstructor.vue?vue&type=script&lang=js&"
export * from "./StatConstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d99fb",
  null
  
)

/* custom blocks */
import block0 from "./StatConstructor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports